<template>
  <b-container fluid>
    <Nav ref="preview-nav" @show-purchase-flow="toggleShowPuchaseFlow(true)" />

    <PurchaseFlowModal :show-plans="true" @start-free-download="startFreeDownload" />

    <PreviewCarousel
      v-if="!showDownload && actualVector"
      :vector="actualVector"
      carousel_id="modalCarousel_vexels"
      @show-purchase-flow="$bvModal.show('purchase-modal')"
    />

    <FreeDownload v-if="showDownload" />

    <Relateds />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Nav from '@/components/Preview/Nav';
import PreviewCarousel from '@/components/Preview/Carousel';
import Relateds from '@/components/Preview/Relateds';
import PurchaseFlowModal from '@/components/PurchaseFlow/Modal';
import FreeDownload from '@/components/PurchaseFlow/FreeDownload';

export default {
  name: 'PreviewVector',
  components: {
    Nav,
    PreviewCarousel,
    Relateds,
    PurchaseFlowModal,
    FreeDownload
  },
  data: () => {
    return {
      showDownload: false
    };
  },
  computed: {
    ...mapGetters('vectors', ['isLoading', 'showPurchaseFlow', 'actualVector'])
  },
  methods: {
    startFreeDownload() {
      this.$bvModal.hide('purchase-modal');
      this.showDownload = true;
    },
    toggleShowPuchaseFlow(show) {
      this.$store.commit('vectors/SET_SHOW_PURCHASE_FLOW', show);
    },
    async vectorClick({ item, shownListing }, e) {
      e.preventDefault();
      this.$bvModal.show('preview-vector-modal');
      await this.$store.dispatch('vectors/OPEN_PREVIEW', { item, list: shownListing });
    }
  }
};
</script>
